export default __webpack_public_path__ + "static/media/logo.26f0e33d.jpg";